import { fetcher } from '@commenda/utils';

export async function deleteCAFirm(caFirmId: string, token: string) {
  const response = await fetcher(
    `caFirm/${caFirmId}`,
    {
      method: 'DELETE',
    },
    token
  );

  return response;
}
